// @flow

import pageLoadFeatureData from '@ta/features';

const features = { ...pageLoadFeatureData };
export const loadFeatures = (newFeatures: { [string]: boolean }) => {
  Object.entries(newFeatures).forEach(([name, value]) => {
    features[name] = value;
  });
};

export const featureIsEnabled = (featureName: string) => !!features[featureName];

export default {
  featureIsEnabled,
};
